import { SET_APP_FILTER } from 'src/actions/appFiltersActions';

const initialState = {};

const appFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_FILTER: {
      const page = Object.keys(action.payload)?.[0];
      const filters = action.payload[page];
      return {
        ...state,
        [page]: filters
      };
    }

    default: {
      return state;
    }
  }
};

export default appFiltersReducer;
